import { client } from '@atlassian/rovo-content-bridge-api';

export const ROVO_CHAT_CLIENT_ID = client('rovo-chat');
